import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React, { memo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import RegionCard from '../../components/BasicUI/Cards/RegionCard';
import { routeConfiguration } from '../../index';
import { createResourceLocatorString } from '../../util/routes';

const destinations = [
  {
    title: 'NRW',
    subtitle: 'Wohnmobilstellplätze',
    image: {
      filename: 'https://a.storyblok.com/f/267180/480x280/3afa38c06e/nrw-480p.webp',
      alt: 'Splash of Germany Bayern Castle',
      title: 'Splash of Germany Bayern Castle',
    },
    slug: 'wohnmobilstellplatz',
    rest: 'nrw',
  },
  {
    title: 'Bayern',
    subtitle: 'Wohnmobilstellplätze',
    image: {
      filename: 'https://a.storyblok.com/f/267180/640x427/c0f7caec8e/bayern.webp',
      alt: 'Lavendel Wiesen in Frankreich',
      title: 'Lavendel Wiesen in Frankreich',
    },
    slug: 'wohnmobilstellplatz',
    rest: 'bayern',
  },
  {
    title: 'Niedersachsen',
    subtitle: 'Wohnmobilstellplätze',
    image: {
      filename: 'https://a.storyblok.com/f/267180/640x427/340065c7ca/niedersachsen.webp',
      alt: 'Italy Coast',
      title: 'Italy Coast',
    },
    slug: 'wohnmobilstellplatz',
    rest: 'niedersachsen',
  },
  {
    title: 'Sachsen',
    subtitle: 'Wohnmobilstellplätze',
    image: {
      filename: 'https://a.storyblok.com/f/267180/640x347/1ff926721e/sachsen.webp',
      alt: 'Mountains of swiss',
      title: 'Mountains of swiss',
    },
    slug: 'wohnmobilstellplatz',
    rest: 'sachsen',
  },
  {
    title: 'Schleswig-Holstein',
    subtitle: 'Wohnmobilstellplätze',
    image: {
      filename: 'https://a.storyblok.com/f/267180/640x427/c4e8aedbbf/schleswig.webp',
      alt: 'Austra view of mountains',
      title: 'Austra view of mountains',
    },
    slug: 'wohnmobilstellplatz',
    rest: 'schleswig-holstein',
  },
  {
    title: 'Hessen',
    subtitle: 'Wohnmobilstellplätze',
    image: {
      filename:
        'https://a.storyblok.com/f/267180/444x250/72bae63cda/dsc_6499-scaled-p96weu984j2k093e731lnhj453jl4zumo0k15g6k8w.jpeg',
      alt: 'Coast of Spain',
      title: 'Coast of Spain',
    },
    slug: 'wohnmobilstellplatz',
    rest: 'hessen',
  },
  {
    title: 'Bodensee',
    subtitle: 'Wohnmobilstellplätze',
    image: {
      filename: 'https://a.storyblok.com/f/267180/2000x1333/dfd7142031/bodensee.webp',
      alt: 'Bodensee mit Booten auf dem See und einer Stadt im Vordergrund',
      title: 'Bodensee mit Booten auf dem See und einer Stadt im Vordergrund',
    },
    slug: 'wohnmobilstellplatz',
    rest: 'bodensee',
  },
  {
    title: 'Chiemsee',
    subtitle: 'Wohnmobilstellplätze',
    image: {
      filename: 'https://a.storyblok.com/f/267180/640x360/06c873b1a1/chiemsee.webp',
      alt: 'Segelboote und ein weiteres Schiff fahren auf dem Chiemsee',
      title: 'Segelboote und ein weiteres Schiff fahren auf dem Chiemsee',
    },
    slug: 'wohnmobilstellplatz',
    rest: 'chiemsee',
  },
  {
    title: 'Bremen',
    subtitle: 'Wohnmobilstellplätze',
    image: {
      filename:
        'https://a.storyblok.com/f/267180/640x467/25bca63ed0/jahanzeb-ahsan-nvnoy_dkvxa-unsplash.webp',
      alt: 'Wohnmobilstellplatz Bremen',
      title: 'Wohnmobilstellplatz Bremen',
    },
    slug: 'wohnmobilstellplatz',
    rest: 'bremen',
  },
  {
    title: 'Ostsee',
    subtitle: 'Wohnmobilstellplätze',
    image: {
      filename: 'https://a.storyblok.com/f/267180/2399x1396/0f264d1fd8/title-image-ostsee.webp',
      alt: 'Strand an der Ostsee.',
      title: 'Strand an der Ostsee.',
    },
    slug: 'wohnmobilstellplatz',
    rest: 'ostsee',
  },
  {
    title: 'Cuxhaven',
    subtitle: 'Wohnmobilstellplätze',
    image: {
      filename: 'https://a.storyblok.com/f/267180/640x679/03106f6d9b/jw-slryeb8awfk-unsplash.webp',
      alt: 'Wohnmobilstellplatz Cuxhaven',
      title: 'Wohnmobilstellplatz Cuxhaven',
    },
    slug: 'wohnmobilstellplatz',
    rest: 'cuxhaven',
  },
  {
    title: 'Allgäu',
    subtitle: 'Wohnmobilstellplätze',
    image: {
      filename: 'https://a.storyblok.com/f/267180/1920x1280/cc98a78dbb/allgau-optimized-1080p.webp',
      alt: 'Wohnmobilstellplatz Cuxhaven',
      title: 'Wohnmobilstellplatz Cuxhaven',
    },
    slug: 'wohnmobilstellplatz',
    rest: 'allgaeu',
  },
  // Add more destinations as needed
];

const SectionRegionsComponent = () => {
  const intl = useIntl();

  return (
    <Container
      maxWidth="xl"
      sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 4 }}
    >
      <Typography component="h2" sx={{ mb: 2 }} variant="h3">
        <FormattedMessage id="SectionRegions.header" />
      </Typography>
      <Grid container justifyContent="center" spacing={2}>
        {destinations.map((destination, index) => {
          const link = createResourceLocatorString(
            'StoryblokPage',
            routeConfiguration(),
            { slug: destination.slug, rest: destination.rest },
            {},
            intl.locale,
          );

          return (
            <Grid key={index} size={{ lg: 4, md: 6, xs: 12 }}>
              <RegionCard
                image={destination.image}
                link={link}
                subtitle={destination.subtitle}
                title={destination.title}
              />
            </Grid>
          );
        })}
      </Grid>
    </Container>
  );
};

SectionRegionsComponent.displayName = 'SectionRegions';
const SectionRegions = memo(SectionRegionsComponent);
export default SectionRegions;
